<div class="esvrDispatchContainer">
  <div class="arrow-up"></div>
  <h1>{{'Dispatch.DispatchESVR' | translate}}</h1>

  <p>
    This action can not be reverted.
  </p>
  <p>Are you sure you want to dispatch this ESVR?</p>
  <!-- <button (click)="close()">Close</button> -->
  <div class="actioncontainer">
    <button mat-raised-button type="button" (click)="close()" class="cmn-draft-btn">
      No
    </button>
    <button mat-raised-button type="button" (click)="confirm()" class="cmn-green-btn">
      Yes
    </button>
  </div>
</div>